export const REQUEST_CU_COURSE = "request_cu_course"
export const CU_COURSE_SUCCESS = "cu_course_success"
export const CU_COURSE_FAILURE = "cu_course_failure"

export const CLEAR_CU_COURSE = "clear_cu_course"